"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var StackView_1 = require("../StackView");
var helpers_1 = require("../helpers");
var Tile_1 = require("./Tile");
var ColumnHeaderRoot = styled_components_1.default(StackView_1.StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n"], ["\n    height: ", ";\n"])), helpers_1.SIZE_L);
exports.ColumnHeader = helpers_1.createUIElement('ColumnHeader', function (_a, ref) {
    var className = _a.className, children = _a.children, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(ColumnHeaderRoot, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-ColumnHeader " + className, root: true, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
exports.TopLegend = styled_components_1.default(StackView_1.StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: -", "px;\n    left: -4px;\n    right: -4px;\n    ", " {\n        // TODO: use theme after theme refactoring and add helpers for this (spacing.xxl + spacing.s)\n        width: ", ";\n    }\n"], ["\n    position: absolute;\n    top: -", "px;\n    left: -4px;\n    right: -4px;\n    ", " {\n        // TODO: use theme after theme refactoring and add helpers for this (spacing.xxl + spacing.s)\n        width: ", ";\n    }\n"])), 24 + 4, exports.ColumnHeader.selector, function (_a) {
    var tileSize = _a.tileSize;
    return "calc(" + Tile_1.calcTileWidth(tileSize) + " + 8px)";
});
exports.TopLegendHeader = styled_components_1.default(StackView_1.StackView)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: -", "px;\n\n    ", "\n"], ["\n    position: absolute;\n    top: -", "px;\n\n    ",
    "\n"])), 24 + 4 + 16 + 8, function (_a) {
    var sideOffset = _a.sideOffset;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            left: calc(4px - ", "px);\n            right: calc(4px - ", "px);\n        "], ["\n            left: calc(4px - ", "px);\n            right: calc(4px - ", "px);\n        "])), sideOffset, sideOffset);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=TopLegend.js.map